import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const ReCaptcha = ({ onVerify }) => {
  const recaptchaRef = React.createRef();

  const handleOnChange = (token) => {
    onVerify(token);
  };

  return (
    <div>
      <ReCAPTCHA
        ref={recaptchaRef}
        // sitekey="6Le-VC4qAAAAAOeYXi-ztnS8-Q_lJyp7AQRwRO72"
        sitekey={process.env.REACT_APP_SITE_KEY}
        onChange={handleOnChange}
      />
    </div>
  );
};

export default ReCaptcha;
